import { Button } from '@chikara/ui';
import { LOGIN } from '@/shared/constants/routes';
import styles from './Onboarding.module.css';
import { t } from '@/i18n';

interface OnboardingErrorScreenProps {
    title?: string | null;
    message?: string | null;
    hideButton?: boolean;
}

export function OnboardingErrorScreen({ title, message, hideButton }: OnboardingErrorScreenProps) {
    return (
        <div className={styles.errorContainer}>
            <h2 className={styles.errorTitle}>{title ?? t('onboarding.error.title')}</h2>
            <p className={styles.errorMessage}>{message ?? t('onboarding.error.subtitle')}</p>
            {!hideButton && (
                <Button onClick={() => (window.location.href = LOGIN)} className={styles.submitButton}>
                    {t('onboarding.error.action')}
                </Button>
            )}
        </div>
    );
}
